import { randomArray } from '@library/common/functions';
import { MockPath, MockPagination } from '@library/common/http/mock-path.mock';

import { Shipment } from '@library/common/models/shipment';
import { ShipmentFactory } from '@library/common/models/mock';
import { MockShipmentSnapshot } from './snapshot/shipment-snapshot.mock';

export const ShipmentsRoutes: MockPath<Shipment<any, any>>[] = [
   { path: 'shipment', verb: 'GET', type: 'shipment', collection: () => [ ShipmentFactory.mock() ] },
   { path: 'shipment/list', verb: 'POST', type: 'shipments', response: opts => ({
      collection: randomArray( MockShipmentSnapshot ),
      pagination: MockPagination( opts?.body?.pagination ),
   })},
];
